/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Sujal's Portfolio",
  description:
    "Cloud-savvy DevOps enthusiast with expertise in AWS, Azure, GCP, blockchain, and proficient in Python and Java, eager to bridge development and operations for future tech innovations.",
  og: {
    title: "Sujal Dua Portfolio",
    type: "website",
    url: "http://0Sujal.github.io/",
  },
};

//Home Page
const greeting = {
  title: "Sujal Dua",
  logo_name: "Sujal Dua",
  subTitle:
    "Cloud-savvy DevOps enthusiast with expertise in AWS, Azure, GCP, blockchain, and proficient in Python and Java, eager to bridge development and operations for future tech innovations.",
  resumeLink:
    "https://drive.google.com/file/d/1Y7H1FaoxEp3ANgBLHa42WRsyiWi97kiP/view?usp=drive_link",

};

const socialMediaLinks = [
  /* Your Social Media Link */
  // github: "https://github.com/0Sujal/",
  // linkedin: "https://www.linkedin.com/in/sujaldua/",
  // gmail: "sujaldua28@gmail.com"
  {
    name: "Github",
    link: "https://github.com/0Sujal/",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/sujaldua/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "Gmail",
    link: "mailto:sujaldua28@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  {
    name: "Dev.io",
    link: "https://dev.to/sujal_dua",
    fontAwesomeIcon: "fa-brands fa-dev", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=gmail
  },
];

const skills = {
  data: [
    {
      title: "Data Science & Gen. AI",
      fileName: "DataScienceImg",
      skills: [
        "► Engineered robust, production-grade models tailored to a variety of deep learning and statistical applications, ensuring scalability and efficiency for enterprise-level deployments.",
        "► Spearheaded cutting-edge Computer Vision and NLP projects, successfully implementing innovative solutions that significantly advanced the fields of image recognition and natural language understanding.",
        "► Pioneered sophisticated quantitative modeling techniques for dynamic forecasting and time series analysis, delivering highly accurate predictive insights and optimizing strategic decision-making processes.",
      ],
      softwareSkills: [
        {
          skillName: "Tensorflow",
          fontAwesomeClassname: "logos-tensorflow",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "PyTorch",
          fontAwesomeClassname: "logos-pytorch",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
        {
          skillName: "Deeplearning",
          imageSrc: "deeplearning_ai_logo.png",
        },
      ],
    },
    {
      title: "Cloud and DevOps",
      fileName: "CloudInfraImg",
      skills: [
        "► Deployed more than 20 ML models on cloud infrastructure, enabling efficient and accessible use on mobile devices, resulting in a 30% increase in user engagement.",
        "► Successfully hosted and maintained over 50 websites on virtual machine instances, seamlessly integrating databases to ensure robust, reliable web services with 99.5% uptime.",
        "► Set up and managed over 100 streaming jobs from databases to servers or vice-versa on GCP and AWS, ensuring smooth and continuous data flow with zero downtime for real-time applications.",
        "► Working on multiple cloud platforms, leveraging each platform's unique capabilities to enhance performance and achieve 99.9% scalability.",
      ],
      softwareSkills: [
        {
          skillName: "GCP",
          fontAwesomeClassname: "simple-icons:googlecloud",
          style: {
            color: "#4285F4",
          },
        },
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: {
            color: "#FF9900",
          },
        },
        {
          skillName: "Azure",
          fontAwesomeClassname: "simple-icons:microsoftazure",
          style: {
            color: "#0089D6",
          },
        },
        {
          skillName: "Terraform",
          fontAwesomeClassname: "devicon-plain:terraform-wordmark",
          style: {
            color: "#FFCA28",
          },
        },
        {
          skillName: "GitLab",
          fontAwesomeClassname: "devicon-plain:gitlab-wordmark",
          style: {
            color: "#336791",
          },
        },
        {
          skillName: "Jenkins",
          fontAwesomeClassname: "logos:jenkins",
          style: {
            color: "#336791",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#1488C6",
          },
        },
        {
          skillName: "Kubernetes",
          fontAwesomeClassname: "simple-icons:kubernetes",
          style: {
            color: "#326CE5",
          },
        },
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "LeetCode",
      iconifyClassname: "simple-icons:leetcode",
      style: {
        color: "#F79F1B",
      },
      profileLink: "https://leetcode.com/u/sujaldua28/",
    },
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://www.hackerrank.com/profile/sujaldua28",
    },
    {
      siteName: "Microsoft Learn",
      iconifyClassname: "simple-icons:microsoft",
      style: {
        color: "#1E90FF",
      },
      profileLink: "https://learn.microsoft.com/en-us/users/sujaldua/",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Chandigarh University, Mohali, Punjab",
      subtitle: "B.E. in Computer Science and Engineering",
      logo_path: "uil--university.png",
      alt_name: "handigarh University",
      duration: "2021 - 2025",
      descriptions: [
        "I have studied basic software engineering subjects like DS, Algorithms, DBMS, OS, CN, AI etc.",
        "Apart from this, I have done courses on Cloud Computing, Data Science, DevOps and Data Analytics.",
        "Our team was the National Winner of NASA International Space App Challenge 2023.",
        "Our team secured the Second position Institute-wise at Project-Expo 2024.",
      ],
      website_link: "https://www.cuchd.in/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "GitHub Foundations",
      subtitle: "Git Hub",
      logo_path: "mdi--github.png",
      certificate_link:
        "https://www.credly.com/badges/aa4b51d9-4b72-4df5-9b04-ca9a60ae403b/linked_in_profile",
      alt_name: "GitHub Foundations",
      color_code: "#8C151599",
    },
    {
      title: "Google Cloud Cybersecurity Certificate",
      subtitle: "Google Cloud Platform",
      logo_path: "skill-icons--gcp-dark.png",
      certificate_link:
        "https://www.credly.com/badges/143fee22-516b-4a0e-9959-6ab43c2eed91/linked_in_profile",
      alt_name: "Google Cloud Cybersecurity Certificate",
      color_code: "#00000099",
    },
    {
      title: "Oracle Cloud Infrastructure 2024 Generative AI Certified Professional",
      subtitle: "Oracle Cloud",
      logo_path: "Oracle.png",
      certificate_link:
        "https://catalog-education.oracle.com/pls/certview/sharebadge?id=B33E01BAA4F278C4F6DC596B54ACEB3D69A241D69E0F2E03ADC44DA439025DA8",
      alt_name: "Oracle Cloud Infrastructure 2024 Generative AI Certified Professional",
      color_code: "#0C9D5899",
    },
    {
      title: "Microsoft Certified: Azure AI Fundamentals",
      subtitle: "Microsoft Azure",
      logo_path: "microsoft_logo.png",
      certificate_link:
        "https://learn.microsoft.com/en-us/users/sujaldua/credentials/f7bc50052f544bc3",
      alt_name: "Microsoft Certified: Azure AI Fundamentals",
      color_code: "#1F70C199",
    },
    {
      title: "AWS Academy Graduate - AWS Academy Cloud Architecting",
      subtitle: "Amazon Web Services Training and Certification",
      logo_path: "mdi--aws.png",
      certificate_link:
        "https://www.credly.com/badges/255a775f-0b9e-49f1-81bd-a8c631e18057/linked_in_profile",
      alt_name: "AWS Academy Graduate - AWS Academy Cloud Architecting",
      color_code: "#D83B0199",
    },
    {
      title: "Data Visualization with Tableau",
      subtitle: "University of California, Davis",
      logo_path: "UOC.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/specialization/LB8PMVWQ7D2Q",
      alt_name: "Data Visualization with Tableau",
      color_code: "#1F70C199",
    },
    {
      title: "Redis | RU102PY: Redis for Python Developers",
      subtitle: "Redis ",
      logo_path: "simple-icons--redis.png",
      certificate_link:
        "https://university.redis.com/certificates/adecc7440a4e43d4b54493ed2a33f362",
      alt_name: "Google",
      color_code: "#0C9D5899",
    },
    {
      title: "Gremlin Certified Chaos Engineering Practitioner - GCCEP",
      subtitle: "Gremlin",
      logo_path: "download.png",
      certificate_link:
        "https://certification.gremlin.com/e9f88fc6-70ab-4945-a6e9-2a7dc786aa2f",
      alt_name: "Gremlin",
      color_code: "#00000099",
    },
    {
      title: "Introducing Generative AI with AWS",
      subtitle: "Udacity",
      logo_path: "logos--udacity-icon.png",
      certificate_link:
        "https://www.udacity.com/certificate/e/d39010ea-3098-11ef-b1c7-7f7112a069c7",
      alt_name: "Introducing Generative AI with AWS",
      color_code: "#2A73CC",
    },
    {
      title: "Cloud Engineering",
      subtitle: "Google Cloud Platform",
      logo_path: "skill-icons--gcp-dark.png",
      certificate_link:
        "https://google.qwiklabs.com/public_profiles/e4d5a92b-faf6-4679-a70b-https://www.cloudskillsboost.google/public_profiles/51ea15c5-751e-4049-aa0d-a7ce6de2bf10/badges/9442567?utm_medium=social&utm_source=linkedin&utm_campaign=ql-social-share",
      alt_name: "GCP",
      color_code: "#4285F499",
    },
    {
      title: "Google AI Essentials",
      subtitle: "Google",
      logo_path: "google_logo.png",
      certificate_link:
        "https://www.credly.com/badges/3600097b-b581-41eb-a436-235b90048ef7/linked_in_profile",
      alt_name: "Google AI Essentials",
      color_code: "#FFBB0099",
    },
    {
      title: "Java as a Second Language Specialization",
      subtitle: "LearnQuest",
      logo_path: "coursera_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/specialization/QARHNS9TD62Q",
      alt_name: "LearnQuest",
      color_code: "#4285F499",
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Internship and Volunteership",
  description:
    "Developed expertise in Cloud and DevOps, proficient in AWS, Azure, and CI/CD pipelines.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Internship",
      work: true,
      experiences: [
        {
          title: "Summer Intern",
          company: "Metacrafters Pvt. Ltd.",
          logo_path: "Meta.png",
          duration: "June 2023 - August 2023",
          location: "Remote",
          description:
            "With a profound understanding of blockchain principles, I’m proficient in Solidity, and web3.js, applying both theory and practice in developing smart contracts and decentralized applications. During my internship at Metacrafters, I gained valuable real-world project experience, further fueling my passion for the blockchain industry.",
          color: "#000000",
        },
      ],
    },
    {
      title: "Volunteership",
      experiences: [
        {
          title: "Microsoft Student Ambassador",
          company: "Microsoft",
          logo_path: "microsoft_logo.png",
          duration: "October 2023 - Present",
          location: "Chandigarh University",
          description:
            "Student Ambassadors are a global group of campus leaders who are eager to help fellow students, create robust tech communities, and develop technical and career skills for the future.",
          color: "#000000",
        },
        {
          title: "Class Representative",
          company: "Chandigarh University",
          logo_path: "uil--university.png",
          duration: "Auguest 2023 - Present",
          location: "Chandigarh University",
          description:
            "As a Class Representative at Chandigarh University, my role involves acting as a liaison between students and faculty, ensuring effective communication and addressing concerns promptly. I organize and coordinate class activities, facilitate discussions, and contribute to a positive learning environment.",
          color: "#ee3c26",
        },
      ],
    },
    {
      title: "Achievments",
      experiences: [
        {
          title: "National Top Performers in NASA INTERNATIONAL SPACE APP CHALLENGE",
          company: "NASA",
          logo_path: "simple-icons--nasa.png",
          duration: "October 2023 - January 2024",
          location: "Mohali, Punjab",
          description:
            "We are the AstroGuide Team, a group dedicated to crafting the future of space exploration, education, and travel through our AstroGuide . Led by a team of skilled researchers and students, our collective expertise combines general computer science knowledge with specialized AI/ML capabilities. We're united by a passion for the cosmos and a shared vision of inspiring the world through technology.",
          color: "#4285F4",
        },
        {
          title: "Second position Institute-wise at Project Expo 2024",
          company: "Chandigarh University",
          logo_path: "uil--university.png",
          duration: "Aprol 2024 - June 2024",
          location: "Mohali, Punjab",
          description:
            "Our project, the RC Motor Boat for Water Quality and Monitoring System, garnered immense recognition for its innovative approach towards sustainability and future-forward solutions.",
          color: "#D83B01",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "In the realms of Cloud, DevOps, and AI, I have developed and deployed innovative real-world applications that demonstrate my technical expertise and problem-solving abilities. These projects include advanced cloud solutions, efficient CI/CD pipelines, and intelligent AI models, all designed to address practical challenges and drive transformative outcomes in various industries.",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  title: "Technical Articles",
  description: "Some of my published Articles, Blogs and Research.",
  avatar_image_path: "projects_image.svg",
};

const publications = {
  data: [
    {
      id: "neuro-symbolic-sudoku-solver",
      name: "Neuro-Symbolic Sudoku Solver",
      createdAt: "2023-07-02T00:00:00Z",
      description: "Paper published in KDD KiML 2023",
      url: "https://arxiv.org/abs/2307.00653",
    },
    {
      id: "mdp-diffusion",
      name: "MDP-Diffusion",
      createdAt: "2023-09-19T00:00:00Z",
      description: "Blog published in Paperspace",
      url: "https://blog.paperspace.com/mdp-diffusion/",
    },
    {
      id: "consistency-models",
      name: "Consistency Models",
      createdAt: "2023-10-12T00:00:00Z",
      description: "Blog published in Paperspace",
      url: "https://blog.paperspace.com/consistency-models/",
    },
  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "cropped-about-pic.png",
    description:
      "Cloud Engineer, DevOps enthusiast, AI explorer.",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "I like to document some of my experiences in professional career journey as well as some technical knowledge sharing.",
    link: "https://dev.to/sujal_dua",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Address",
    subtitle: "Mohali, Punjab, India",
    locality: "Mohali",
    country: "India",
    region: "Punjab",
    avatar_image_path: "address_image.svg",
  },
  phoneSection: {
    title: "",
    subtitle: "",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  publications,
  contactPageData,
};
